import PostDelete from "./PostDelete";
export default PostDelete;
